(function () {
  var selector = [
    '.ugc-grid',
    '.pdp-ugc-scroll',
    '.prod-grid',
    '.pdp-related-grid',
    '.zp-grid',
    '.rc-fit-grid',
    '.el-grid',
    '.sc-prod-grid',
    '.product-grid',
    '.pdp-benefitbar-row',
    '.zsnap-grid',
    '.zf-grid',
    '.zt-grid',
    '.zw-grid',
    '.kc-benefits-grid',
    '.kc-life-grid',
    '.kc-kit-grid',
    '.el-compare-grid',
    '.el-details-grid',
    '.osp-grid',
    '.ps-spotlight'
  ].join(',');

  function enhance(track) {
    if (!window.matchMedia('(max-width: 760px)').matches) return;
    if (track.matches('.oszea-variant-grid, .pdp-stage-track, .pdp-thumbs, .kc-stage-track, .kc-thumbs, .sk-track, .sk-thumbs')) return;
    if (track.matches('.product-grid') && (document.body.classList.contains('template-cart') || document.body.classList.contains('template-search'))) return;
    if (track.dataset.oszeaCarousel || track.children.length < 2) return;
    track.dataset.oszeaCarousel = 'true';
    track.classList.add('oszea-mobile-carousel-track');

    var shell = document.createElement('div');
    shell.className = 'oszea-mobile-carousel-shell';
    if (track.matches('.ugc-grid, .pdp-ugc-scroll')) shell.classList.add('oszea-mobile-carousel-shell--video');
    track.parentNode.insertBefore(shell, track);
    shell.appendChild(track);

    var prev = document.createElement('button');
    var next = document.createElement('button');
    prev.type = next.type = 'button';
    prev.className = 'oszea-mobile-carousel-arrow oszea-mobile-carousel-arrow--prev';
    next.className = 'oszea-mobile-carousel-arrow oszea-mobile-carousel-arrow--next';
    prev.setAttribute('aria-label', 'Previous items');
    next.setAttribute('aria-label', 'Next items');
    prev.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="display:block;margin:auto;"><path d="M15 18l-6-6 6-6"/></svg>';
    next.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="display:block;margin:auto;"><path d="M9 18l6-6-6-6"/></svg>';
    shell.appendChild(prev);
    shell.appendChild(next);

    function step(direction) {
      var card = track.firstElementChild;
      var amount = card ? card.getBoundingClientRect().width + 12 : track.clientWidth * 0.85;
      track.scrollBy({ left: direction * amount, behavior: 'smooth' });
    }
    function update() {
      prev.disabled = track.scrollLeft < 5;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 5;
    }
    prev.addEventListener('click', function () { step(-1); });
    next.addEventListener('click', function () { step(1); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  }

  function init(root) {
    (root || document).querySelectorAll(selector).forEach(enhance);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  function toggleFooterMenu(heading) {
    if (!window.matchMedia('(max-width: 560px)').matches) return;
    var column = heading.closest('.foot-col');
    if (!column) return;
    column.classList.toggle('open');
    heading.setAttribute('aria-expanded', column.classList.contains('open') ? 'true' : 'false');
  }
  document.addEventListener('click', function (event) {
    var heading = event.target.closest('.foot-col > h4[role="button"]');
    if (heading) toggleFooterMenu(heading);
  });
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    var heading = event.target.closest('.foot-col > h4[role="button"]');
    if (!heading) return;
    event.preventDefault();
    toggleFooterMenu(heading);
  });
  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches(selector)) enhance(node);
        init(node);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
